import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefplan-rollen-pruefer-entfernen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanRollenPrueferEntfernenEffects {

    PruefplanRollenPrueferEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFPLAN_ROLLEN_PRUEFER_ENTFERNEN),
        mergeMap((x: ac.PostPruefplanRollenPrueferEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefplanRollenPrueferEntfernen(x.pruefplanRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefplanRollenPrueferEntfernenErfolgreichAction(result, x.pruefplanRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefplanRollenPrueferEntfernenFehlerAction(error, x.pruefplanRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
